import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { SourceType } from '@returnmates/client-core/src/constants/sourceType'
import { Trip } from '@returnmates/client-core/src/graphql/generated/api'
import clsx from 'clsx'
import moment from 'moment-timezone'
import { memo } from 'react'

import useStyles from '../styles'

interface Props {
  currentTrip: Trip | null
}

const TripSource = ({ currentTrip }: Props) => {
  const classes = useStyles()

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.headerRow}>
          <TableCell className={classes.headerCell}>Date</TableCell>
          <TableCell className={classes.headerCell}>Source</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow className={classes.tableRow}>
          <TableCell className={clsx(classes.bodyCell, classes.noWrapText)}>
            {currentTrip?.createdAt
              ? moment
                  .unix(currentTrip.createdAt)
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format('M/D/YY h:mm A z')
              : null}
          </TableCell>
          <TableCell className={classes.bodyCell}>
            {`Created via ${currentTrip?.source?.replaceAll('_', ' ')} ${
              currentTrip?.source === SourceType.WILSON
                ? currentTrip?.createdBy
                  ? `- ${currentTrip?.tracking?.at(-1)?.createdBy?.email?.replace('_', ' ')}`
                  : ''
                : ''
            }`}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}
export default memo(TripSource)
